// extracted by mini-css-extract-plugin
module.exports = {"unauthenticatedView":"KnowledgeDetails_unauthenticatedView__3MvxH","headerContainer":"KnowledgeDetails_headerContainer__28GLY","layoutItem":"KnowledgeDetails_layoutItem__2_hqK"};